export default "__VITE_ASSET__BrNAHNuJ__"